import { LineChart, Line, BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from "recharts";
import type { DeliveryReportRow, DeliveryReportTimeline } from "../../api/reports";
import "./report-charts.css";

interface ReportChartsProps {
    timelineData: DeliveryReportTimeline[];
    byFlyerData: DeliveryReportRow[];
    byTeamData: DeliveryReportRow[];
}

export const ReportCharts = ({
    timelineData,
    byFlyerData,
    byTeamData,
}: ReportChartsProps): JSX.Element => {
    const timelineChartData = timelineData
        .map((item) => ({
            date: new Date(item.date).toLocaleDateString("sv-SE"),
            deliveries: item.deliveries,
            quantity: item.quantity,
        }))
        .sort((a, b) => new Date(a.date).getTime() - new Date(b.date).getTime());

    const flyerChartData = byFlyerData.slice(0, 10).map((item) => ({
        name: item.flyerName,
        deliveries: item.deliveries,
        quantity: item.quantitySum || 0,
    }));

    const teamChartData = byTeamData.slice(0, 10).map((item) => ({
        name: item.flyerName,
        deliveries: item.deliveries,
        quantity: item.quantitySum || 0,
    }));

    return (
        <div className="report-charts">
            {timelineData.length > 0 && (
                <div className="report-charts__chart">
                    <h3>Tidslinje - Utdelningar över tid</h3>
                    <ResponsiveContainer width="100%" height={300}>
                        <LineChart data={timelineChartData}>
                            <CartesianGrid strokeDasharray="3 3" />
                            <XAxis dataKey="date" />
                            <YAxis />
                            <Tooltip />
                            <Legend />
                            <Line type="monotone" dataKey="deliveries" stroke="#3b82f6" name="Antal utdelningar" />
                            <Line type="monotone" dataKey="quantity" stroke="#10b981" name="Antal flygblad" />
                        </LineChart>
                    </ResponsiveContainer>
                </div>
            )}

            {flyerChartData.length > 0 && (
                <div className="report-charts__chart">
                    <h3>Top 10 vanligaste flygbladen</h3>
                    <ResponsiveContainer width="100%" height={300}>
                        <BarChart data={flyerChartData}>
                            <CartesianGrid strokeDasharray="3 3" />
                            <XAxis dataKey="name" angle={-45} textAnchor="end" height={100} />
                            <YAxis />
                            <Tooltip />
                            <Legend />
                            <Bar dataKey="deliveries" fill="#3b82f6" name="Antal utdelningar" />
                            <Bar dataKey="quantity" fill="#10b981" name="Antal flygblad" />
                        </BarChart>
                    </ResponsiveContainer>
                </div>
            )}

            {teamChartData.length > 0 && (
                <div className="report-charts__chart">
                    <h3>Top 10 teams</h3>
                    <ResponsiveContainer width="100%" height={300}>
                        <BarChart data={teamChartData}>
                            <CartesianGrid strokeDasharray="3 3" />
                            <XAxis dataKey="name" angle={-45} textAnchor="end" height={100} />
                            <YAxis />
                            <Tooltip />
                            <Legend />
                            <Bar dataKey="deliveries" fill="#3b82f6" name="Antal utdelningar" />
                            <Bar dataKey="quantity" fill="#10b981" name="Antal flygblad" />
                        </BarChart>
                    </ResponsiveContainer>
                </div>
            )}

            {timelineData.length === 0 && flyerChartData.length === 0 && teamChartData.length === 0 && (
                <div className="report-charts__empty">
                    <p>Inga data hittades för de valda filtren.</p>
                </div>
            )}
        </div>
    );
};